import { createSelector } from '@reduxjs/toolkit';
import { FDealType } from '../../../../packages/JsonQuery';
import { selectDealType } from 'shared/selectors/jsonQuery';

export const selectDefaultPriceLabel = createSelector(selectDealType, dealType =>
  dealType === FDealType.RentDaily ? 'Цена за сутки' : 'Цена',
);
